import normalizeVS from './normalize.vs';
import normalizeFS from './normalize.fs';
import normalizeEdlFS from './normalize_and_edl.fs';
import edlVS from './edl.vs';
import edlFS from './edl.fs';
import blurVS from './blur.vs';
import blurFS from './blur.fs';

export const Shaders: Record<string, string> = {
  'normalize.vs': normalizeVS,
  'normalize.fs': normalizeFS,
  'normalize_and_edl.fs': normalizeEdlFS,
  'edl.vs': edlVS,
  'edl.fs': edlFS,
  'blur.vs': blurVS,
  'blur.fs': blurFS,
};
